import type { LocalizedText } from './data/schema'

/**
 * House terms for reader-facing product language.
 *
 * Entity names do not belong here. Their canonical display forms live in
 * public/data/nodes.json, while alternate forms remain searchable aliases.
 */
export const platformTerms = {
  atlas: { 'zh-Hant': '神話地圖', en: 'myth atlas' },
  relationshipMap: { 'zh-Hant': '關係圖', en: 'relationship map' },
  mapItem: { 'zh-Hant': '神話項目', en: 'mythic item' },
  mapDisplay: { 'zh-Hant': '地圖呈現', en: 'Map view' },
  mapSymbols: { 'zh-Hant': '圖示說明', en: 'Map symbols' },
  storyMode: { 'zh-Hant': '故事導讀', en: 'Story mode' },
  storyCycle: { 'zh-Hant': '神話系列', en: 'myth cycle' },
  chapter: { 'zh-Hant': '章', en: 'Chapter' },
  relationship: { 'zh-Hant': '關係', en: 'Relationship' },
  context: { 'zh-Hant': '脈絡', en: 'Context' },
  source: { 'zh-Hant': '原典來源', en: 'Ancient sources' },
  acrossMyths: { 'zh-Hant': '跨神話', en: 'Across myths' },
} as const satisfies Record<string, LocalizedText>

export const nodeTypeTerms = {
  deity: { 'zh-Hant': '神祇', en: 'Deity' },
  hero: { 'zh-Hant': '英雄', en: 'Hero' },
  mortal: { 'zh-Hant': '凡人', en: 'Mortal' },
  creature: { 'zh-Hant': '神話生物', en: 'Creature' },
  place: { 'zh-Hant': '地點', en: 'Place' },
  event: { 'zh-Hant': '事件', en: 'Event' },
  artifact: { 'zh-Hant': '器物', en: 'Artifact' },
} as const satisfies Record<string, LocalizedText>

export const edgeTypeTerms = {
  family: { 'zh-Hant': '親屬', en: 'Family' },
  help: { 'zh-Hant': '援助', en: 'Aid' },
  conflict: { 'zh-Hant': '衝突', en: 'Conflict' },
  love: { 'zh-Hant': '情愛', en: 'Love' },
  participation: { 'zh-Hant': '參與', en: 'Participation' },
  geography: { 'zh-Hant': '地點關聯', en: 'Location' },
  causality: { 'zh-Hant': '因果', en: 'Cause' },
  creation: { 'zh-Hant': '創造', en: 'Creation' },
  possession: { 'zh-Hant': '持有', en: 'Possession' },
} as const satisfies Record<string, LocalizedText>

/**
 * High-confidence transliteration variants that remain valid search aliases
 * but must not replace the house form in authored Traditional Chinese prose.
 */
export const entityProseAliasRules = [
  { entityId: 'aeaea', forbiddenAliases: ['埃埃亞'] },
  { entityId: 'ithaca', forbiddenAliases: ['伊塔卡'] },
  { entityId: 'muses', forbiddenAliases: ['繆思'] },
  { entityId: 'poseidon', forbiddenAliases: ['波塞頓', '波賽頓'] },
  { entityId: 'telemachus', forbiddenAliases: ['忒勒瑪科斯', '泰勒馬科斯'] },
] as const
